// The catalog, for a page that may sit outside the game (PLAN-CLIENT-SPLIT day 8).
//
// The front door is drawn before anybody has a board, and `App` mounts the
// `GameContext` provider around the shell alone — so a page reads the context
// where it is provided and takes the catalog as a prop where it is not. The
// catalog is static, so either road hands back the same tables.

import { useContext } from "react";

import type { Catalog } from "src/api";

import { GameContext } from "../useGame";

export function useCatalog(given?: Catalog): Catalog {
  const catalog = useContext(GameContext)?.catalog ?? given;
  if (!catalog) {
    throw new Error("useCatalog outside GameContext: pass `catalog={game.catalog}` to the page");
  }
  return catalog;
}
